import { adverseConditions } from './conditions'
import { adverseScenarios } from './steps'
import { adverseTexts } from './texts'
import type { IOnboardingModule } from '../../types/IOnboardingModule'

export const adverseOnboarding: IOnboardingModule = {
  scenarios: adverseScenarios,
  texts: adverseTexts,
  conditions: adverseConditions,
}
